var _path;
/*
 * The MIT License (MIT)
 *
 * Copyright (c) 2015 - present Instructure, Inc.
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in all
 * copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
 * SOFTWARE.
 */
import { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';
import { jsx as _jsx } from "@emotion/react/jsx-runtime";
class IconMoveDownBottomLine extends Component {
  constructor(...args) {
    super(...args);
    this.ref = null;
    this.handleRef = el => {
      const elementRef = this.props.elementRef;
      this.ref = el;
      if (typeof elementRef === 'function') {
        elementRef(el);
      }
    };
  }
  render() {
    return _jsx(SVGIcon, {
      ...this.props,
      name: "IconMoveDownBottom",
      viewBox: "0 0 1920 1920",
      elementRef: this.handleRef,
      children: _path || (_path = _jsx("path", {
        d: "M106.667 141v1280H457.92l-175.573-175.68 75.306-75.413 304.427 304.32-304.427 304.426-75.306-75.413 175.573-175.573H0V141h106.667Zm960 1279.904v106.667H853.333v-106.667h213.334Zm426.666 0v106.667H1280v-106.667h213.333Zm426.667 0v106.667h-213.333v-106.667H1920Zm0-426.667v106.774H533.333V994.237H1920Zm0-426.666v106.666H533.333V567.571H1920Zm0-426.56v106.666H533.333V141.011H1920Z",
        fillRule: "evenodd"
      }))
    });
  }
}
IconMoveDownBottomLine.glyphName = 'move-down-bottom';
IconMoveDownBottomLine.variant = 'Line';
IconMoveDownBottomLine.displayName = 'IconMoveDownBottomLine';
// eslint-disable-next-line react/forbid-foreign-prop-types
IconMoveDownBottomLine.propTypes = {
  ...SVGIcon.propTypes
};
IconMoveDownBottomLine.allowedProps = [...SVGIcon.allowedProps];
export default IconMoveDownBottomLine;
export { IconMoveDownBottomLine };